import type { ThirdPartyMembers, UserEmails } from '../../common/types';

export const getUserEmails = (members: ThirdPartyMembers[] | null): UserEmails => {
	if (!members || members.length === 0) return {};

	const userEmailMappings: UserEmails = {};
	members.forEach((member) => {
		if (member.email) {
			userEmailMappings[member.id] = { emailId: member.email };
		}
	});

	return userEmailMappings;
};
